import React, { forwardRef } from "react";
import { FaAsterisk } from "react-icons/fa";
import { twMerge } from "tailwind-merge";

export interface InputProps extends React.HTMLProps<HTMLInputElement> {
  isRequired?: boolean;
  labelClassName?: string;
}

const Input = forwardRef<HTMLInputElement, React.PropsWithRef<InputProps>>(
  (props, ref) => {
    const { className, isRequired, label, labelClassName, ...rest } = props;
    return (
      <div>
        <div className="flex justify-start items-start mb-1.5">
          {label ? (
            <label className={twMerge("text-white", labelClassName)}>
              {label}
            </label>
          ) : (
            <></>
          )}
          {isRequired ? (
            <FaAsterisk className="fill-primary-red-50 pt-1" size={12} />
          ) : (
            <></>
          )}
        </div>
        <div className="">
          <input
            className={twMerge(
              "h-[46px] rounded-md px-5 py-2.5 text-sm w-full focus:outline-none",
              className
            )}
            ref={ref}
            {...rest}
          />
        </div>
      </div>
    );
  }
);

export default Input;
